export const ApprovalStatus = {
    PENDING: 'PENDING',
    APPROVED: 'APPROVED',
    RETURNED: 'RETURNED',
    /** крок чекав рішення, коли розклад повернули на іншому кроці (не рахується як «повернули») */
    CANCELLED: 'CANCELLED',
};
/** Значення в порядку оголошення в схемі. */
export const APPROVAL_STATUS_VALUES = ['PENDING', 'APPROVED', 'RETURNED', 'CANCELLED'];
export const APPROVAL_STATUS_LABELS = {
    PENDING: 'Очікує рішення',
    APPROVED: 'Погоджено',
    RETURNED: 'Повернуто',
    CANCELLED: 'Скасовано',
};
/** Пояснення скасованого кроку (підказка / коментар у маршруті). */
export const APPROVAL_CANCELLED_REASON = 'Скасовано: розклад повернули на іншому кроці';
export const APPROVAL_STATUS_TONES = {
    PENDING: 'warning',
    APPROVED: 'success',
    RETURNED: 'danger',
    CANCELLED: 'neutral',
};
//# sourceMappingURL=approval-status.js.map